























































































































	import {Prop} from "vue-property-decorator";
	import {Component, Vue} from '@/shared/component';
	import {Stored} from "vue-stored-prop-decorator/index";
	import storeUser from "@/stores/modules/user";
	import { createStore } from 'devextreme-aspnet-data-nojquery';
	import {Token, User} from "@/models";
	import storeToken from "@/stores/modules/token";
	import 'devextreme/dist/css/dx.light.css';
	import {
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxFilterRow,
			DxHeaderFilter,
			DxGroupPanel,
			DxGrouping,
			DxScrolling,
			DxSummary,
			DxLookup,
			DxTotalItem,
			DxGroupItem,
			DxMasterDetail,
			DxStringLengthRule,
			DxRequiredRule,
			DxRangeRule,
			DxValueFormat,
			DxPaging,
			DxPager,
			DxExport,
			DxStateStoring,
		} from 'devextreme-vue/data-grid';
import {Achat, BoisType, LongueursAchat} from '@/models';

import CrudAchatFilter from '@/components/Crud/Achat/Filter.vue';
import CrudAchatEditDialog from '@/components/Crud/Achat/EditDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import {ResultType} from '@/shared/xhttp';
import storeLongueursAchat from "@/stores/modules/longueursAchat";
import storeBoisType from "@/stores/modules/boisType";

import storeAchat, {AchatFilterListEnCours} from '@/stores/modules/achat';
import DxButton from 'devextreme-vue/button';
import axios from "axios";

	@Component({
		components: {
			DxButton,
			DxDataGrid,
			DxColumn,
			DxEditing,
			DxFilterRow,
			DxHeaderFilter,
			DxGroupPanel,
			DxGrouping,
			DxScrolling,
			DxSummary,
			DxLookup,
			DxTotalItem,
			DxGroupItem,
			DxMasterDetail,
			DxStringLengthRule,
			DxRangeRule,
			DxRequiredRule,
			DxValueFormat,
			DxPaging,
			DxPager,			
			DxExport,
			DxStateStoring,
			CrudAchatEditDialog,
			CrudDeleteDialog,
			}
	})

	export default class CrudAchatList extends Vue {
		
		@Stored(() => storeToken) token!: Token;

		@Stored(() => storeAchat) private achats!: ResultType<Achat>;
		@Stored(() => storeAchat) private filters!: AchatFilterListEnCours;

		private storeLongueursAchat = storeLongueursAchat
		private storeBoisType = storeBoisType;

		private editAchat: Achat = null;
		private deletedAchat: Achat = null;
		private storeAchat = storeAchat;
		private dataGrid;

		private dataSource = null;

		public async mounted(): Promise<void> 
		{
			await storeLongueursAchat.dispatch('getC', {filters: false});
			await storeBoisType.dispatch('getC', {filters: false});
			this.filters.BoisSurPied = false;
			await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/achats/fetch-encours/" + this.filters.BoisSurPied + "?token=" + this.token.id, {}).then(async response => {
				this.dataSource = await response.data;
			});
			
			this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
			for(let result of this.dataSource.types_bois){
				if (this.dataSource.totaux[result] !== 0)
				{
					//var columns = this.dataGrid.option("columns");  
					//columns.push(result.key);  
					//this.dataGrid.option("columns", columns);  			
					this.dataGrid.instance.addColumn(result);
					this.dataGrid.instance.columnOption(result, "width", 55); 
					this.dataGrid.instance.columnOption(result, "cellTemplate", "quantite"); 
					this.dataGrid.instance.columnOption(result, "headerCellTemplate", "titleheader"); 
				}
			}
			this.dataGrid.instance.addColumn("remarques");
			this.dataGrid.instance.columnOption("remarques", "width", 150); 
			this.dataGrid.instance.columnOption("remarques", "cellTemplate", "remarques"); 

			this.dataGrid.instance.addColumn("name");
			this.dataGrid.instance.columnOption("name", "caption", "Fournisseur"); 

			this.dataGrid.instance.addColumn("date");
			this.dataGrid.instance.columnOption("date", "caption", "Date d'achat"); 
			this.dataGrid.instance.columnOption("date", "cellTemplate", "date");

			this.dataGrid.instance.addColumn("date_coupe");
			this.dataGrid.instance.columnOption("date_coupe", "caption", "Date de coupe"); 
			this.dataGrid.instance.columnOption("date_coupe", "cellTemplate", "date_coupe");
		}

		public async refresh(): Promise<void> 
		{
			await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/achats/fetch-encours/" + this.filters.BoisSurPied + "?token=" + this.token.id, {}).then(async response => {
				this.dataSource = await response.data;
			});
		}

		public clearFilters() {
			this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
			this.filters.BoisSurPied = false;
			this.dataGrid.instance.clearFilter()
			//this.dataGrid.instance!.state(null);
			this.refresh();
		}

		private calculateCellValue(data) {
			let date = data.date
			let year = date.substr(2,2)
			let month = date.substr(5,2)
			let day = date.substr(8,2)
			return day + '/' + month + '/' + year
		}

		private calculateCellValueCoupe(data) {
			let date = data.date_coupe
			let year = date.substr(2,2)
			let month = date.substr(5,2)
			let day = date.substr(8,2)
			return day + '/' + month + '/' + year
		}

		public onRowPrepared(e) {
            if (e.rowType === "data") {
                if ((e.dataIndex % 2) != 0) {
                    e.rowElement.style.cssText = "background-color: #eeeeee;";
				}
				
                if (e.data.acces_temps_sec == "1") {
                    e.rowElement.style.cssText = "color: gray; background-color: lightblue;";
                }
                if (e.data.sur_pied == "1") {
                    e.rowElement.style.cssText = "color: gray; background-color: #FFC300;";
                }
            }
        }		
	}
